
// Download handler using existing utilities
import { Options, Vue } from "vue-class-component";
import { downloadFile } from "@/app/infrastructures/misc/Utils";
import { ConfigBucketStorage } from "@/feature-flags/flags-config-bucket-storage";
export default class ButtonDownloadTemplate extends Vue {
  async handleDownloadTemplate(): Promise<void> {
    const url = `${ConfigBucketStorage.config_bucket_prd_genesis.getValue()}/bulk/template/operational_area_template.csv`;
    await downloadFile(url, "operational_area_template", ".csv");
  }
}
